import { TextField } from '@refinedev/antd';
import { useTranslation } from 'react-i18next';

import { ShowInfoGrid, ShowInfoItem } from '@/components/general/ShowInfo/ShowInfo';
import { useCountryContext } from '@/contexts/CountryContext';
import { Reception } from '@/model/Logistic/Reception/Reception';
import { Country, phoneNumberMeta } from '@/utils/phoneNumbers';

interface ReceptionShowReturnAddressProps {
  record?: Reception;
}

const ReceptionShowReturnAddress = (props: ReceptionShowReturnAddressProps) => {
  const { isBrasilSelected } = useCountryContext();
  const { t } = useTranslation();
  const { record } = props;
  const countryCode = Country[record?.receiver_localidad?.provincia?.pais?.id];

  return (
    <ShowInfoGrid>
      <ShowInfoItem label={t('Operador logístico de retorno')}>
        <TextField value={record?.return_shipper?.name} />
      </ShowInfoItem>
      <ShowInfoItem label={t('País')}>
        <TextField value={record?.receiver_localidad?.provincia?.pais?.nombre} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Provincia')}>
        <TextField value={record?.receiver_localidad?.provincia?.nombre} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Localidad')}>
        <TextField value={record?.receiver_localidad?.nombre} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Código postal')}>
        <TextField value={record?.receiver_postal_code ?? '-'} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Dirección')}>
        <TextField value={record?.receiver_address ?? '-'} />
      </ShowInfoItem>
      {isBrasilSelected && (
        <>
          <ShowInfoItem label={t('Número')}>
            <TextField value={record?.receiver_address_number ?? '-'} />
          </ShowInfoItem>
          <ShowInfoItem label={t('Complemento')}>
            <TextField value={record?.receiver_address_complement ?? '-'} />
          </ShowInfoItem>
        </>
      )}
      <ShowInfoItem label={t('Email')}>
        <TextField value={record?.receiver_email ?? '-'} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Número de teléfono')}>
        <TextField
          value={
            record?.receiver_phone && countryCode
              ? `${phoneNumberMeta[countryCode].phoneCountry} ${record?.receiver_phone}`
              : '-'
          }
        />
      </ShowInfoItem>
      <ShowInfoItem label={t('Nombre y apellido del destinatario')}>
        <TextField value={record?.receiver_name} />
      </ShowInfoItem>
      {record?.receiver_delivery_instructions && (
        <ShowInfoItem label={t('Instrucciones para la entrega')}>
          <TextField value={record?.receiver_delivery_instructions} />
        </ShowInfoItem>
      )}
    </ShowInfoGrid>
  );
};

export default ReceptionShowReturnAddress;
